<template>
    <div>
      <card>
        <div class="searchDiv">
        <b-form-group label="Search Course:">
          <b-form-input
            class="search"
            v-model="searchCourseNumber"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Search vehicle:">
          <b-form-input
            class="search"
            v-model="searchCourseNumber"
          ></b-form-input>
        </b-form-group>
      </div>
        <b-table
          id="my-table"
          :items="filteredItems"
          :fields="fields"
          :per-page="perPage"
          style="table-layout:fixed; width:90%;"
          :current-page="currentPage"
          striped
          hover
          responsive="sm"
        >
          <template #cell(Trip)="data">
            <b-button
              size="sm"
              @click="toggleTripDetails(data.item)"
              class="mr-2"
            >
              {{ data.item.showStopDetails ? 'Hide' : 'Show' }} Trips
            </b-button>
            {{ data.item.Trip }}
            <b-collapse :visible="data.item.showStopDetails">
              <b-card class="openedCard">
                <b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right">All trips:</b-col>
                  <b-col>
                    <b-list-group style="max-height: 200px; overflow: auto">
                      <b-list-group-item
                        v-for="(trip, index) in data.item.allTrips"
                        :key="index"
                      >
                        <b-form-checkbox
                          :checked="trip.isSelected"
                          @change="() => selectTrip(data.item, index)"
                        >
                          {{ trip.tripName }}
                        </b-form-checkbox>
                      </b-list-group-item>
                    </b-list-group>
                    <b-button @click="toggleAllTrips(data.item)">
                      {{
                        data.item.allTrips.every((trip) => trip.isSelected)
                          ? 'Uncheck'
                          : 'Check'
                      }}
                      All trips
                    </b-button>
                  </b-col>
                </b-row>
                <b-row>
                  <b-button
                    @click="
                      cancelRoutes(data.item.allTrips, data.item.Course_number)
                    "
                    >Cancel selected trips</b-button
                  >
                </b-row>
              </b-card>
            </b-collapse>
          </template>
  
          <template #cell(Trip_stops)="data">
            <b-button
             :disabled="!data.item.allTrips.some(trip => trip.isSelected)"
              size="sm"
              @click="toggleRouteDetails(data.item)"
              class="mr-2"
            >
              {{ data.item.showTripStopDetails ? ' ' : ' ' }} Stops
            </b-button>
            <b-collapse :visible="data.item.showTripDetails">
              <b-card class="openedCard">
                <b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right"> All trip Stops: </b-col>
                  <b-col>
                    <b-list-group style="max-height: 200px; overflow: auto">
                      <b-list-group-item
                        v-for="(stop, index) in data.item.tripStops"
                        :key="index"
                      >
                        <b-form-checkbox v-model="stop.isSelected">{{
                          stop.tripStop
                        }}</b-form-checkbox>
                      </b-list-group-item>
                    </b-list-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-button @click="cancelRoutes(data.item.tripStops)"
                    >Cancel trips</b-button
                  >
                </b-row>
              </b-card>
            </b-collapse>
          </template>
  
          <template #cell(Cancel_course)="data">
            <b-button @click="cancelCourse(data.item.Course_number)">
              Cancel course {{ data.item.Course_number }}
            </b-button>
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="my-table"
          class="mb-3"
        ></b-pagination>
      </card>
    </div>
  </template>
  <script>
  import coursesData from '@/store/content/coursesData.js'
  
  export default {
    data() {
      return {
        searchCourseNumber: '',
        fields: ['Course_number', 'Trip', 'Trip_stops', 'Cancel_course'],
        items: coursesData.items,
        currentPage: 1,
        perPage: 3,
      }
    },
    methods: {
        selectTrip(item, selectedTripIndex) {
        // state of clicked trip
        const isAlreadySelected = item.allTrips[selectedTripIndex].isSelected
  
        // deselect all trips
        item.allTrips.forEach((trip) => {
            trip.isSelected = false
        })
  
        // if the trip was not yet selected, select it
        if (!isAlreadySelected) {
          item.allTrips[selectedTripIndex].isSelected = true
          // show the trip details after a new trip is now selected
          item.showTripDetails = true
        } else {
          // if it was already selected and is now deselected, hide the trips details
          item.showTripDetails = false
        }
      },
      toggleTripDetails(item) {
        // Show trips, showStopDetails needs to be renamed to match changes to UI
        item.showStopDetails = !item.showStopDetails
  
        // when hiding the trips, also hide the trip stops card and deselect all checkboxes
        if (!item.showStopDetails) {
          item.showTripDetails = false
          item.allTrips.forEach((trip) => {
            trip.isSelected = false // deselect each trip
          })
        }
      },
      toggleRouteDetails(item) {
        item.showTripDetails = false;
      },
      cancelRoutes(allTrips, Course_number) {
        const selectedTrips = allTrips.filter((trip) => trip.isSelected)
        const tripNames = selectedTrips.map((trip) => trip.tripName)
        console.log(
          'Selected trips for cancellation:',
          tripNames,
          'for route',
          Course_number
        )
      },
      cancelCourse(courseNumber) {
        console.log('Cancelled course:', courseNumber)
      },
      toggleAllTrips(item) {
        const areAllChecked = item.allTrips.every((trip) => trip.isSelected)
        item.allTrips.forEach((trip) => {
            trip.isSelected = !areAllChecked
        })
      },
    },
    created() {
      if (!this.$store.state.items)
        this.$store.registerModule('items', coursesData)
    },
    computed: {
      rows() {
        return this.filteredItems.length
      },
      filteredItems() {
        if (!this.searchCourseNumber) {
          return this.items
        }
        return this.items.filter((item) => {
          return item.Course_number.toString().includes(
            this.searchCourseNumber.toString()
          )
        })
      },
    },
  }
  </script>
  
  <style scoped lang="scss">
  .search {
    max-width: 90px;
    min-width: 60px;
    flex: 1;
    border-spacing: 5em;
  }

  .searchDiv {
    display:  flex;
    gap: 50px;
    border-spacing: 5em;
    justify-content:left;
  }

  .openedCard {
    max-width: 90%;
    overflow:auto;
  }
  </style>
  ```
  